var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup3725(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2325",
    "data-name": "Rectangle 2325",
    width: 35,
    height: 34,
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3725",
    "data-name": "Group 3725",
    transform: "translate(-934 -464)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3724",
    "data-name": "Group 3724",
    transform: "translate(934 464)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3723",
    "data-name": "Group 3723",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50603",
    "data-name": "Path 50603",
    d: "M13.443,5H3.869A2.82,2.82,0,0,0,1,7.871",
    transform: "translate(-0.043 -0.214)",
    fill: "none",
    stroke: "#505050",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50604",
    "data-name": "Path 50604",
    d: "M31.614,8.829V5H23",
    transform: "translate(-0.986 -0.214)",
    fill: "none",
    stroke: "#505050",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50605",
    "data-name": "Path 50605",
    d: "M33.543,25.229v7.657H3.871A2.822,2.822,0,0,1,1,30.014V8a2.822,2.822,0,0,0,2.871,2.871H33.543v6.7",
    transform: "translate(-0.043 -0.343)",
    fill: "none",
    stroke: "#505050",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50606",
    "data-name": "Path 50606",
    d: "M6,10.571,19.4,1l6.7,9.571",
    transform: "translate(-0.257 -0.043)",
    fill: "none",
    stroke: "#505050",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50607",
    "data-name": "Path 50607",
    d: "M34.443,18H25.829a3.829,3.829,0,0,0,0,7.657h8.614A.957.957,0,0,0,35.4,24.7V18.957A.957.957,0,0,0,34.443,18Z",
    transform: "translate(-0.943 -0.771)",
    fill: "none",
    stroke: "#505050",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_234",
    "data-name": "Line 234",
    x2: 2,
    transform: "translate(25 21)",
    fill: "none",
    stroke: "#505050",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3725);
export default __webpack_public_path__ + "static/media/Group3725.829b08eb531c5c74ec1c98ee93007440.svg";
export { ForwardRef as ReactComponent };